import { parsePhoneNumberWithError } from 'libphonenumber-js';



/*
  Convert any phone-number value the BE might hand us into a string for
  display. Three shapes are accepted:

    1. Canonical E.164 with leading '+' ("+14155555510")  →
         "+1 (415) 555-5510"  — render the country code.

    2. Country code without leading '+' ("14155555510")  →
         "+1 (415) 555-5510"  — new wire format the BE accepts. Treated
         the same as E.164 for display purposes.

    3. Bare 10-digit US legacy data ("4155555510")  →
         "(415) 555-5510"     — pre-i18n records have no country code
         recorded, so we don't invent one. (Decision: render without a
         country code rather than assume +1.)

  Anything else (empty/null/unparseable) returns null so consumers can
  decide whether to render an em dash, a placeholder, or skip the row.
*/

const LEGACY_BARE_US_LENGTH = 10;

function formatLegacyBareUs(digits) {
  const a = digits.slice(0, 3);
  const b = digits.slice(3, 6);
  const c = digits.slice(6);

  return `(${a}) ${b}-${c}`;
}



export default function formatPhoneForDisplay(value) {
  if (value == null || value === '') return null;

  const stringValue = String(value).trim();

  if (!stringValue) return null;

  const digitCount = stringValue.replace(/\D/g, '').length;

  if (digitCount === LEGACY_BARE_US_LENGTH && !stringValue.startsWith('+')) {
    return formatLegacyBareUs(stringValue.replace(/\D/g, ''));
  }

  const e164 = stringValue.startsWith('+') ? stringValue : `+${stringValue}`;

  try {
    const parsed = parsePhoneNumberWithError(e164);

    return `+${parsed.countryCallingCode} ${parsed.formatNational()}`;
  }

  catch (_error) {
    return stringValue;
  }
}
